"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageInstancePaymentStatusToJSON = exports.PackageInstancePaymentStatusFromJSONTyped = exports.PackageInstancePaymentStatusFromJSON = exports.PackageInstancePaymentStatus = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var PackageInstancePaymentStatus;
(function (PackageInstancePaymentStatus) {
    PackageInstancePaymentStatus["Paid"] = "paid";
    PackageInstancePaymentStatus["Failed"] = "failed";
    PackageInstancePaymentStatus["Scheduled"] = "scheduled";
    PackageInstancePaymentStatus["Shared"] = "shared";
    PackageInstancePaymentStatus["Cancelled"] = "cancelled";
})(PackageInstancePaymentStatus || (exports.PackageInstancePaymentStatus = PackageInstancePaymentStatus = {}));
function PackageInstancePaymentStatusFromJSON(json) {
    return PackageInstancePaymentStatusFromJSONTyped(json, false);
}
exports.PackageInstancePaymentStatusFromJSON = PackageInstancePaymentStatusFromJSON;
function PackageInstancePaymentStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.PackageInstancePaymentStatusFromJSONTyped = PackageInstancePaymentStatusFromJSONTyped;
function PackageInstancePaymentStatusToJSON(value) {
    return value;
}
exports.PackageInstancePaymentStatusToJSON = PackageInstancePaymentStatusToJSON;
//# sourceMappingURL=PackageInstancePaymentStatus.js.map